import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const IDLE_KEY = "cs_last_activity";
const IDLE_MS = 3 * 60 * 60 * 1000;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = verifica, false = non autenticato

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      if (e.response?.status === 401) {
        try {
          await api.post("/auth/refresh");
          const { data } = await api.get("/auth/me");
          setUser(data);
          return;
        } catch {}
      }
      setUser(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    localStorage.removeItem(IDLE_KEY);
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  const signIn = (u) => { if (u) localStorage.setItem(IDLE_KEY, String(Date.now())); setUser(u); };

  useEffect(() => {
    if (!user) return undefined;
    let last = 0;
    const touch = () => { const n = Date.now(); if (n - last > 30000) { last = n; localStorage.setItem(IDLE_KEY, String(n)); } };
    const check = () => {
      const seen = parseInt(localStorage.getItem(IDLE_KEY) || "0", 10);
      if (seen && Date.now() - seen > IDLE_MS) {
        localStorage.removeItem(IDLE_KEY);
        logout().then(() => toast.info("Sei stato disconnesso dopo 3 ore di inattività. Accedi di nuovo per continuare."));
      }
    };
    check();
    touch();
    const evs = ["pointerdown", "keydown", "scroll", "mousemove", "touchstart"];
    evs.forEach((e) => window.addEventListener(e, touch, { passive: true }));
    const id = setInterval(check, 60000);
    return () => { evs.forEach((e) => window.removeEventListener(e, touch)); clearInterval(id); };
  }, [user?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AuthContext.Provider value={{ user, setUser: signIn, logout, checkAuth }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
